<h2>Umsätze</h2>

<!-- Menü / Nav pills -->
<div class="btn-group spacer-top spacer-bottom" style="align-content: center;">
  <label class="btn btn-primary" ng-model="vm.view" uib-btn-radio="'summary'">Überblick</label>
  <label class="btn btn-primary" ng-model="vm.view" uib-btn-radio="'cash'">Bar-Umsätze</label>
  <label class="btn btn-primary" ng-model="vm.view" uib-btn-radio="'check'">Umsatz auf Rechnung</label>
</div>

<!-- --------------------------------------------------------------------------------------------------------------- -->
<!-- Summary view -->
<!-- --------------------------------------------------------------------------------------------------------------- -->

<div ng-show="vm.view === 'summary'">
  
  <h3>Gesamtumsatz</h3>
  
  <table class="table table-striped">
    <tr>
      <th>Zeitraum</th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos, inkl. offene Beträge">Gesamt Netto</span></th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos, exkl. offene Beträge">Netto verfügbar</span></th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos">Gesamt Brutto</span></th>
      <th class="nrr"><span uib-tooltip="Noch nicht beglichene Rechnungen">Offen</span></th>
      <th class="nrr"><span uib-tooltip="Summiert über alle Umsatzsteuersätze">USt.</span></th>
      <th class="nrr"><span uib-tooltip="Summe stornierter Einzelrechnungen">Storno</span></th>
    
    </tr>
    <tr>
      <td>Heute</td>
      <td class="nrr">{{vm.thisyear.todaycashstats.total + vm.thisyear.todaycheckstats.total
        - vm.thisyear.todaycashstats.tax - vm.thisyear.todaycheckstats.tax | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.todaycashstats.total + vm.thisyear.todaycheckstats.total
        - vm.thisyear.todaycashstats.tax - vm.thisyear.todaycheckstats.tax
        - vm.thisyear.todaycheckstats.open
        | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.todaycashstats.total + vm.thisyear.todaycheckstats.total | currency : '' :
        2}} €
      </td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycashstats.tax + vm.thisyear.todaycheckstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.todaycashstats.storno + vm.thisyear.todaycheckstats.storno | currency : '' :
        2}} €
      </td>
    </tr>
    <tr>
      <td>Diese Woche</td>
      <td class="nrr">{{vm.thisyear.weekcashstats.total + vm.thisyear.weekcheckstats.total
        - vm.thisyear.weekcashstats.tax - vm.thisyear.weekcheckstats.tax | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.weekcashstats.total + vm.thisyear.weekcheckstats.total
        - vm.thisyear.weekcashstats.tax - vm.thisyear.weekcheckstats.tax
        - vm.thisyear.weekcheckstats.open
        | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.weekcashstats.total + vm.thisyear.weekcheckstats.total | currency : '' :
        2}} €
      </td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcashstats.tax + vm.thisyear.weekcheckstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.weekcashstats.storno + vm.thisyear.weekcheckstats.storno | currency : '' :
        2}} €
      </td>
    </tr>
    <tr>
      <td>Dieses Monat</td>
      <td class="nrr">{{vm.thisyear.monthcashstats.total + vm.thisyear.monthcheckstats.total
        - vm.thisyear.monthcashstats.tax - vm.thisyear.monthcheckstats.tax | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.monthcashstats.total + vm.thisyear.monthcheckstats.total
        - vm.thisyear.monthcashstats.tax - vm.thisyear.monthcheckstats.tax
        - vm.thisyear.monthcheckstats.open
        | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.monthcashstats.total + vm.thisyear.monthcheckstats.total | currency : '' :
        2}} €
      </td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcashstats.tax + vm.thisyear.monthcheckstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.monthcashstats.storno + vm.thisyear.monthcheckstats.storno | currency : '' :
        2}} €
      </td>
    </tr>
    <tr>
      <td>Dieses Quartal</td>
      <td class="nrr">{{vm.thisyear.quartercashstats.total + vm.thisyear.quartercheckstats.total
        - vm.thisyear.quartercashstats.tax - vm.thisyear.quartercheckstats.tax | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.quartercashstats.total + vm.thisyear.quartercheckstats.total
        - vm.thisyear.quartercashstats.tax - vm.thisyear.quartercheckstats.tax
        - vm.thisyear.quartercheckstats.open
        | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.quartercashstats.total + vm.thisyear.quartercheckstats.total | currency : ''
        : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercashstats.tax + vm.thisyear.quartercheckstats.tax | currency : '' :
        2}} €
      </td>
      <td class="nrr">{{vm.thisyear.quartercashstats.storno + vm.thisyear.quartercheckstats.storno | currency :
        '' : 2}} €
      </td>
    </tr>
    <tr>
      <td>Dieses Jahr</td>
      <td class="nrr">{{vm.thisyear.yearcashstats.total + vm.thisyear.yearcheckstats.total
        - vm.thisyear.yearcashstats.tax - vm.thisyear.yearcheckstats.tax | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.yearcashstats.total + vm.thisyear.yearcheckstats.total
        - vm.thisyear.yearcashstats.tax - vm.thisyear.yearcheckstats.tax
        - vm.thisyear.yearcheckstats.open
        | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.yearcashstats.total + vm.thisyear.yearcheckstats.total | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcashstats.tax + vm.thisyear.yearcheckstats.tax | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.yearcashstats.storno + vm.thisyear.yearcheckstats.storno | currency : '' :
        2}} €
      </td>
    </tr>
  </table>
  
  
  <h3>Barumsätze</h3>
  
  <table class="table table-striped">
    <tr>
      <th>Zeitraum</th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos, inkl. offene Beträge">Gesamt Netto</span></th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos">Gesamt Brutto</span></th>
      <th class="nrr"><span uib-tooltip="Umsätze durch Bargeld">Bargeld</span></th>
      <th class="nrr"><span uib-tooltip="Umsätze durch Bankomat oder Kreditkarten">Karte</span></th>
      <th class="nrr"><span uib-tooltip="Summiert über alle Umsatzsteuersätze">USt.</span></th>
      <th class="nrr"><span uib-tooltip="Summe stornierter Einzelrechnungen">Storno</span></th>
      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>
    </tr>
    <tr>
      <td>Heute</td>
      <td class="nrr">{{vm.thisyear.todaycashstats.total - vm.thisyear.todaycashstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.todaycashstats.total | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycashstats.cash | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycashstats.card | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycashstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycashstats.storno | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">
        <span class="text-success">{{vm.thisyear.todaycashstats.totalcount - vm.thisyear.todaycashstats.stornocount}}</span>/
        <span class="text-danger">{{vm.thisyear.todaycashstats.stornocount}}</span>,
        {{vm.thisyear.todaycashstats.avg | currency : '' : 2}} € ({{vm.thisyear.todaycashstats.stddev | currency
        : '' : 2}} €) </span>,
      </td>
    </tr>
    <tr>
      <td>Diese Woche</td>
      <td class="nrr">{{vm.thisyear.weekcashstats.total - vm.thisyear.weekcashstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.weekcashstats.total | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcashstats.cash | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcashstats.card | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcashstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcashstats.storno | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">
        <span class="text-success">{{vm.thisyear.weekcashstats.totalcount - vm.thisyear.weekcashstats.stornocount}}</span>/
        <span class="text-danger">{{vm.thisyear.weekcashstats.stornocount}}</span>,
        {{vm.thisyear.weekcashstats.avg | currency : '' : 2}} € ({{vm.thisyear.weekcashstats.stddev | currency
        : '' : 2}} €) </span>,
      </td>
    </tr>
    <tr>
      <td>Dieses Monat</td>
      <td class="nrr">{{vm.thisyear.monthcashstats.total - vm.thisyear.monthcashstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.monthcashstats.total | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcashstats.cash | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcashstats.card | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcashstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcashstats.storno | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">
        <span class="text-success">{{vm.thisyear.monthcashstats.totalcount - vm.thisyear.monthcashstats.stornocount}}</span>/
        <span class="text-danger">{{vm.thisyear.monthcashstats.stornocount}}</span>,
        {{vm.thisyear.monthcashstats.avg | currency : '' : 2}} € ({{vm.thisyear.monthcashstats.stddev | currency
        : '' : 2}} €) </span>,
      </td>
    </tr>
    <tr>
      <td>Dieses Quartal</td>
      <td class="nrr">{{vm.thisyear.quartercashstats.total - vm.thisyear.quartercashstats.tax | currency : '' :
        2}} €
      </td>
      <td class="nrr">{{vm.thisyear.quartercashstats.total | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercashstats.cash | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercashstats.card | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercashstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercashstats.storno | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">
        <span class="text-success">{{vm.thisyear.quartercashstats.totalcount - vm.thisyear.quartercashstats.stornocount}}</span>/
        <span class="text-danger">{{vm.thisyear.quartercashstats.stornocount}}</span>,
        {{vm.thisyear.quartercashstats.avg | currency : '' : 2}} € ({{vm.thisyear.quartercashstats.stddev |
        currency : '' : 2}} €) </span>,
      </td>
    </tr>
    <tr>
      <td>Dieses Jahr</td>
      <td class="nrr">{{vm.thisyear.yearcashstats.total - vm.thisyear.yearcashstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.yearcashstats.total | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcashstats.cash | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcashstats.card | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcashstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcashstats.storno | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">
        <span class="text-success">{{vm.thisyear.yearcashstats.totalcount - vm.thisyear.yearcashstats.stornocount}}</span>/
        <span class="text-danger">{{vm.thisyear.yearcashstats.stornocount}}</span>,
        {{vm.thisyear.yearcashstats.avg | currency : '' : 2}} € ({{vm.thisyear.yearcashstats.stddev | currency :
        '' : 2}} €) </span>,
      </td>
    </tr>
  </table>
  
  
  <h3>Umsatz auf Rechnung</h3>
  
  <table class="table table-striped">
    <tr>
      <th>Zeitraum</th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos, inkl. offene Beträge">Gesamt Netto</span></th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos, exkl. offene Beträge">Netto verfügbar</span></th>
      <th class="nrr"><span uib-tooltip="abzgl. Stornos">Gesamt Brutto</span></th>
      <th class="nrr"><span uib-tooltip="Bereits beglichene Rechnungen">Bezahlt</span></th>
      <th class="nrr"><span uib-tooltip="Noch nicht beglichene Rechnungen">Offen</span></th>
      <th class="nrr"><span uib-tooltip="Summiert über alle Umsatzsteuersätze">USt.</span></th>
      <th class="nrr"><span uib-tooltip="Summe stornierter Einzelrechnungen">Storno</span></th>
      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>
    </tr>
    <tr>
      <td>Heute</td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.total - vm.thisyear.todaycheckstats.tax -
        vm.thisyear.todaycheckstats.storno| currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.total - vm.thisyear.todaycheckstats.tax -
        vm.thisyear.todaycheckstats.open | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.total| currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.paid | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.todaycheckstats.storno | currency : '' : 2}} €</td>
      <td class="nrr">
        <span class="text-success">{{vm.thisyear.todaycheckstats.totalcount - vm.thisyear.todaycheckstats.stornocount}}</span>/<span
          class="text-danger">{{vm.thisyear.todaycheckstats.stornocount}}</span>,
        {{vm.thisyear.todaycheckstats.avg | currency : '' : 2}} € ({{vm.thisyear.todaycheckstats.stddev |
        currency : '' : 2}} €)</span>,
      </td>
    </tr>
    <tr>
      <td>Diese Woche</td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.total - vm.thisyear.weekcheckstats.tax -
        vm.thisyear.weekcheckstats.storno| currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.total - vm.thisyear.weekcheckstats.tax -
        vm.thisyear.weekcheckstats.open | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.total| currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.paid | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.weekcheckstats.storno | currency : '' : 2}} €</td>
      <td class="nrr">
        <span class="text-success">{{vm.thisyear.weekcheckstats.totalcount - vm.thisyear.weekcheckstats.stornocount}}</span>/<span
          class="text-danger">{{vm.thisyear.weekcheckstats.stornocount}}</span>,
        {{vm.thisyear.weekcheckstats.avg | currency : '' : 2}} € ({{vm.thisyear.weekcheckstats.stddev |
        currency : '' : 2}} €)</span>,
      </td>
    </tr>
    <tr>
      <td>Dieses Monat</td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.total - vm.thisyear.monthcheckstats.tax -
        vm.thisyear.monthcheckstats.storno| currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.total - vm.thisyear.monthcheckstats.tax -
        vm.thisyear.monthcheckstats.open | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.total| currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.paid | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.monthcheckstats.storno | currency : '' : 2}} €</td>
      <td class="nrr">
        <span class="text-success">{{vm.thisyear.monthcheckstats.totalcount - vm.thisyear.monthcheckstats.stornocount}}</span>/<span
          class="text-danger">{{vm.thisyear.monthcheckstats.stornocount}}</span>,
        {{vm.thisyear.monthcheckstats.avg | currency : '' : 2}} € ({{vm.thisyear.monthcheckstats.stddev |
        currency : '' : 2}} €)</span>,
      </td>
    </tr>
    <tr>
      <td>Dieses Quartal</td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.total - vm.thisyear.quartercheckstats.tax | currency : ''
        : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.total - vm.thisyear.quartercheckstats.tax -
        vm.thisyear.quartercheckstats.open | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.total| currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.paid | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.quartercheckstats.storno | currency : '' : 2}} €</td>
      <td class="nrr">
        <span class="text-success">{{vm.thisyear.quartercheckstats.totalcount - vm.thisyear.quartercheckstats.stornocount}}</span>/<span
          class="text-danger">{{vm.thisyear.quartercheckstats.stornocount}}</span>,
        {{vm.thisyear.quartercheckstats.avg | currency : '' : 2}} € ({{vm.thisyear.quartercheckstats.stddev |
        currency : '' : 2}} €)</span>,
      </td>
    </tr>
    <tr>
      <td>Dieses Jahr</td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.total - vm.thisyear.yearcheckstats.tax | currency : '' : 2}}
        €
      </td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.total - vm.thisyear.yearcheckstats.tax -
        vm.thisyear.yearcheckstats.open | currency : '' : 2}} €
      </td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.total| currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.paid | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.open | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{vm.thisyear.yearcheckstats.storno | currency : '' : 2}} €</td>
      <td class="nrr">
        <span class="text-success">{{vm.thisyear.yearcheckstats.totalcount - vm.thisyear.yearcheckstats.stornocount}}</span>/<span
          class="text-danger">{{vm.thisyear.yearcheckstats.stornocount}}</span>,
        {{vm.thisyear.yearcheckstats.avg | currency : '' : 2}} € ({{vm.thisyear.yearcheckstats.stddev | currency
        : '' : 2}} €)</span>,
      </td>
    </tr>
  </table>


</div>


<!-- --------------------------------------------------------------------------------------------------------------- -->
<!-- Cash View -->
<!-- --------------------------------------------------------------------------------------------------------------- -->
<div ng-show="vm.view === 'cash'">
  <h3>Barumsätze</h3>
  
  <!-- per year -->
  <h4>Jahresübersicht</h4>
  <table class="table table-striped">
    <tr>
      <th class="nrr">Jahr</th>
      <th class="nrr">Gesamt</th>
      <th class="nrr">Bar</th>
      <th class="nrr">Karte</th>
      <th class="nrr">Ust.</th>
      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>
    </tr>
    <tr ng-repeat="line in vm.yearlycashstats">
      <td class="nrr">{{ line._id.year}}</td>
      <td class="nrr">{{ line.total | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.cash | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.card | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.tax | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">
        <span class="text-success" ng-bind="line.invcount"></span>/
        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;
        <span class="text-primary">{{ line.avg | currency : '' : 2}} €</span>&nbsp;
      </td>
    </tr>
  </table>
  <!-- per month -->
  <h4>Monatsübersicht</h4>
  <table class="table table-striped">
    <tr>
      <th class="nrr">Monat</th>
      <th class="nrr">Gesamt</th>
      <th class="nrr">Bar</th>
      <th class="nrr">Karte</th>
      <th class="nrr">Ust.</th>
      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>
    </tr>
    <tr ng-repeat="line in vm.monthlycashstats">
      <td class="nrr">{{ line._id.month}}/{{ line._id.year}}</td>
      <td class="nrr">{{ line.total | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.cash | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.card | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.tax | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">
        <span class="text-success" ng-bind="line.invcount"></span>/
        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;
        <span class="text-primary">{{ line.avg | currency : '' : 2}} €</span>&nbsp;
      </td>
    </tr>
  </table>
  
</div>

<!-- --------------------------------------------------------------------------------------------------------------- -->
<!-- Check View -->
<!-- --------------------------------------------------------------------------------------------------------------- -->
<div ng-show="vm.view === 'check'">
  <h3>Umsatz auf Rechnung</h3>
  
  
  <!-- per year -->
  <h4>Jahresübersicht</h4>
  <table class="table table-striped">
    <tr>
      <th class="nrr">Jahr</th>
      <th class="nrr">Gesamt</th>
      <th class="nrr">Ust.</th>
      <th class="nrr">Bezahlt</th>
      <th class="nrr">Offen</th>
      <th class="nrr">Stats</th>
    </tr>
    <tr ng-repeat="line in vm.yearlycheckstats">
      <td class="nrr">{{ line._id.year}}</td>
      <td class="nrr">{{ line.total | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.paid | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.open | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">
        <span class="text-success" ng-bind="line.invcount"></span>/
        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;
        <span class="text-primary">{{ line.avg | currency : '' : 2}} €</span>&nbsp;
      </td>
    </tr>
  </table>
  
  <!-- per month -->
  <h4>Monatsübersicht</h4>
  <table class="table table-striped">
    <tr>
      <th class="nrr">Monat</th>
      <th class="nrr">Gesamt</th>
      <th class="nrr">Ust.</th>
      <th class="nrr">Bezahlt</th>
      <th class="nrr">Offen</th>
      <th class="nrr">Stats</th>
    </tr>
    <tr ng-repeat="line in vm.monthlycheckstats">
      <td class="nrr">{{ line._id.month}}/{{ line._id.year}}</td>
      <td class="nrr">{{ line.total | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.tax | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.paid | currency : '' : 2}} €</td>
      <td class="nrr">{{ line.open | currency : '' : 2}} €</td>
      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">
        <span class="text-success" ng-bind="line.invcount"></span>/
        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;
        <span class="text-primary">{{ line.avg | currency : '' : 2}} €</span>&nbsp;
      </td>
    </tr>
  </table>
</div>